import React from 'react';
import { Route } from 'react-router-dom';
import { useAuth } from "./auth.js";
import { Redirect } from 'react-router'
function TeacherRoute({ component: Component, ...rest }) {
    const user = useAuth();
    return(
        <Route {...rest} render={(props) => (
            user.user.isAuthenticated !== undefined ? 
            (user.user.isAuthenticated && (user.user.adminId != null || user.user.teacherId != null) ? (
                <Component {...props} />
            ) : (
                <Redirect to={{
                    pathname: "/login",
                    state: { referrer: window.location.pathname }
                  }} />
            )) : <></>
        )}
        />
    );
}

export default TeacherRoute;